"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'grid',
        gridTemplateColumns: 'repeat(8, 1fr)',
        gridGap: 10,
        gridAutoRows: 'minmax(25px, auto)',
        textAlign: 'right',
        padding: '4px 0',
        fontSize: 10,
        textTransform: 'uppercase',
        color: `${theme.grey4}`
    },
    columnTitle: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gridColumn: '1/5',
        letterSpacing: 1,
        fontWeight: 600
    },
    columnTitle1: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gridColumn: '8/8',
        letterSpacing: 1,
        fontWeight: 600
    },
    columnTitle2: {
        textAlign: 'right',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gridColumn: '7/8',
        letterSpacing: 1,
        fontWeight: 600
    },
    columnTitle3: {
        textAlign: 'right',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gridColumn: '5/7',
        letterSpacing: 1,
        fontWeight: 600
    }
});
//# sourceMappingURL=directory.style.js.map